import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { FaTimes } from "react-icons/fa";
import TagInput from "./tagInput";
import { NumericFormat } from "react-number-format";

export default function AddSubsPackage({
  handleSubsPackage,
  show,
  handleClose,
}) {
  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },
    clearErrors,
    setValue,
  } = useForm({
    reValidateMode: "onBlur",
  });

  const handleModalSubmit = (e) => {
    e.preventDefault(); // Mencegah submit form utama
    handleSubmit(onSubmitFunction)(e); // Menjalankan submit khusus modal
  };

  const onSubmitFunction = (data) => {
    const datas = {
      name: data.packageName,
      package_id: data.packageId,
      description: data.description,
      quota: data.quota,
      subs_length: data.subs_length,
      price: data.price,
    };
    handleSubsPackage(datas);
    reset();
    handleClose();
  };

  return (
    <>
      <Modal
        show={show}
        onHide={() => {
          reset();
          handleClose();
        }}
        backdrop="static"
        size="lg"
        centered
      >
        <form onSubmit={handleModalSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Create Subscription Package</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="mb-3 row">
              <label className="col-form-label col-sm-3 text-sm-right">
                Package Name
                <span className="required">*</span>
              </label>
              <div className="col-sm-6 error-placeholder">
                <input
                  type="text"
                  {...register("packageName", {
                    required: "Package Name is required",
                  })}
                  className={`form-control ${
                    errors.packageName ? "is-invalid" : ""
                  }`}
                />
                {errors.packageName && (
                  <div className="invalid-feedback">
                    {errors.packageName.message}
                  </div>
                )}
              </div>
            </div>
            <div className="mb-3 row">
              <label className="col-form-label col-sm-3 text-sm-right">
                Package Code
                <span className="required">*</span>
              </label>
              <div className="col-sm-3 error-placeholder">
                <input
                  type="text"
                  {...register("packageId", {
                    required: "Package Code is required",
                  })}
                  className={`form-control ${
                    errors.packageId ? "is-invalid" : ""
                  }`}
                />
                {errors.packageId && (
                  <div className="invalid-feedback">
                    {errors.packageId.message}
                  </div>
                )}
              </div>
            </div>
            <div className="mb-3 row">
              <label className="col-form-label col-sm-3 text-sm-right">
                Description
              </label>
              <div className="col-sm-6 error-placeholder">
                <textarea
                  type="text"
                  rows={6}
                  {...register("description")}
                  className={`form-control ${
                    errors.description ? "is-invalid" : ""
                  }`}
                />
              </div>
            </div>
            <div className="mb-3 row">
              <label className="col-form-label col-sm-3 text-sm-right">
                Quota
                <span className="required">*</span>
              </label>
              <div className="col-sm-3 error-placeholder">
                <NumericFormat
                  {...register("quota", {
                    required: "Quota is required",
                  })}
                  className={`form-control ${errors.quota ? "is-invalid" : ""}`}
                  thousandSeparator="."
                  decimalSeparator="," // Tidak berpengaruh karena tidak ada desimal
                  allowNegative={false}
                  decimalScale={0} // Pastikan tidak ada angka desimal
                  isNumericString={true}
                  onValueChange={(values) => {
                    setValue("quota", values.value); // Simpan hanya angka tanpa separator ke form state
                  }}
                />
                {errors.quota && (
                  <div className="invalid-feedback">{errors.quota.message}</div>
                )}
              </div>
            </div>
            <div className="mb-3 row">
              <label className="col-form-label col-sm-3 text-sm-right">
                Validity Period (days)
                <span className="required">*</span>
              </label>
              <div className="col-sm-3 error-placeholder">
                <NumericFormat
                  {...register("subs_length", {
                    required: "Validity Period is required",
                  })}
                  className={`form-control ${
                    errors.subs_length ? "is-invalid" : ""
                  }`}
                  thousandSeparator="."
                  decimalSeparator=","
                  allowNegative={false}
                  decimalScale={0}
                  isNumericString={true}
                  onValueChange={(values) => {
                    setValue("subs_length", values.value);
                  }}
                />
                {errors.subs_length && (
                  <div className="invalid-feedback">
                    {errors.subs_length.message}
                  </div>
                )}
              </div>
            </div>
            <div className="mb-3 row">
              <label className="col-form-label col-sm-3 text-sm-right">
                Price (IDR)
                <span className="required">*</span>
              </label>
              <div className="col-sm-3 error-placeholder">
                <NumericFormat
                  {...register("price", {
                    required: "Price is required",
                  })}
                  className={`form-control ${errors.price ? "is-invalid" : ""}`}
                  thousandSeparator="."
                  decimalSeparator="," // Tidak berpengaruh karena tidak ada desimal
                  allowNegative={false}
                  decimalScale={0} // Pastikan tidak ada angka desimal
                  isNumericString={true}
                  onValueChange={(values) => {
                    setValue("price", values.value); // Simpan hanya angka tanpa separator ke form state
                  }}
                />
                {errors.price && (
                  <div className="invalid-feedback">{errors.price.message}</div>
                )}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="danger" onClick={handleClose}>
              Cancel
            </Button>
            <button className="btn btn-success" type="submit">
              Save Changes
            </button>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
}
